import React, { useMemo, useState } from 'react';
import { $generateHtmlFromNodes, RichTextEditor } from '@talentmesh/rte';
import { useController } from 'react-hook-form';
import UIStrings from '@/Utils/UIStrings';
import { TypographyP } from '@/Components/shadcn';
import ProfileGroupForm from './ProfileGroupForm';
import { useCompanyProfileForm } from '@/Context/CompanyContext';

function CompanyDescriptionSection(): React.JSX.Element {
    const { control, setValue } = useCompanyProfileForm();
    const {
        field,
        fieldState: { error },
    } = useController({ control, name: 'companyDescription' });
    const errMsg = error?.message;
    const initialHtml = useMemo(() => field.value, []);
    const [isInitialRender, setIsInitialRender] = useState(true);

    return (
        <ProfileGroupForm
            dataCy="CompanyDescriptionSection"
            title={`${UIStrings.CompanyDescription}*`}
            description={UIStrings.CompanyDescriptionExplanation}
            width="100%"
        >
            <div className="flex w-full flex-col">
                <RichTextEditor
                    data-cy="CompanyDescription"
                    initialHtml={initialHtml}
                    features={['headingStyle', 'bold', 'italic', 'ol', 'ul']}
                    onChange={(editorState, editor) => {
                        editorState.read(() => {
                            setValue('companyDescription', $generateHtmlFromNodes(editor), {
                                shouldValidate: !isInitialRender,
                            });

                            if (isInitialRender) {
                                setIsInitialRender(false);
                            }
                        });
                    }}
                    contentEditableProps={{
                        className: `flex-1 max-h-60 ${errMsg ? 'border border-destructive' : ''}`,
                    }}
                />
                {errMsg && <TypographyP className="text-destructive mt-1">{errMsg}</TypographyP>}
            </div>
        </ProfileGroupForm>
    );
}

export default CompanyDescriptionSection;
